import { render, staticRenderFns } from "./CommunicationsView.vue?vue&type=template&id=93d500e6"
import script from "./CommunicationsView.vue?vue&type=script&lang=js"
export * from "./CommunicationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports